import React from 'react';
import ModuleCollectionRenderer from '../shared/ModuleCollectionRenderer/ModuleCollectionRenderer';
import { PageSectionProps } from './types';
import { ModuleList } from 'utils/modules';
import { NinetailedMode } from 'types/constants';
import { ResolvedVisualSettings } from 'utils/pageHelpers/visualSettings';

/**
 * Renders a page section
 * @param modulesCollection - The modules collection to render within the section
 * @returns The rendered component
 */
const PageSection = (
  props: PageSectionProps & {
    ninetailedMode?: NinetailedMode;
    enrollmentUrl: string;
    visualSettings?: ResolvedVisualSettings;
  },
) => {
  if (props.children) {
    return <div data-testid="pageSection">{props.children}</div>;
  }

  return (
    <div data-testid="pageSection">
      <ModuleCollectionRenderer
        {...props}
        allowedModules={ModuleList.MAIN}
        ninetailedMode={props.ninetailedMode}
        enrollmentUrl={props.enrollmentUrl}
        visualSettings={props.visualSettings}
      />
    </div>
  );
};

export default PageSection;
